<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Relatório de Público Presente</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <b-alert variant="info" :show="!hasData && !hasFilters">
            Este relatório estará disponível somente quando houver ingressos validados.
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="hasData || hasFilters">
        <b-col>
          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Ingressos:</p>
            <b-form-checkbox-group v-model="filters.type">
              <b-form-checkbox-group @input="updateForm('type', $event)" :checked="filters.type" :options="typeOptions"></b-form-checkbox-group>
            </b-form-checkbox-group>
          </b-form-group>

        </b-col>
      </b-row>

      <b-row align-v="end" v-if="hasData || hasFilters">
        <b-col>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Filtros:</p>
            <b-button class="mr-1 mb-1" v-b-modal.filter-origin>Origem</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-number>Número</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-code>Código</b-button>
            <b-button v-if="!randomNumberEnabled" class="mr-1 mb-1" v-b-modal.filter-range>Intervalo</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-batch>Lote</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-dealer>Revendedor</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-date>Data validação</b-button>
          </div>
          <div style="width: 110px;" class="d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Quantidade:</p>
              <b-form-input size="sm" type="number" @input="updateForm('limit', $event)" :value="filters.limit" :disabled="!listValidationsChosen"></b-form-input>
          </div>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <b-button class="mr-1" variant="info" @click="showLast">Limpar filtros</b-button>
            <b-button class="mr-1" variant="info" @click="filter">Filtrar</b-button>
          </div>
          <b-form-group class="w-auto d-inline-block mb-4">
            <p class="mb-2 font-weight-bold">
              Informação adicional:
              <span v-b-tooltip.hover title="Escolha qual informação será exibida abaixo do Gráfico de Horário de Entradas.">
                <icon name="info-circle" scale="0.8"></icon>
              </span>
            </p>
            <b-form-radio-group v-model="step" :options="optionsChart"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="hasData || hasFilters">
        <b-col cols="12" v-if="hasFilters" class="mt-1 mb-3">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col>
          <p class="text-right font-italic">Relatório gerado em {{ report.generated_at | date }}.</p>
        </b-col>
      </b-row>

      <b-row v-if="hasData || hasFilters">
        <b-col class="mb-4">
          <h4 class="mb-3">Gráfico de Horário de Entrada</h4>
          <time-chart v-if="hasData"
            :height="100"
            :labels="chartEntranceLabels"
            :values="chartEntranceValues">
          </time-chart>
        </b-col>
      </b-row>

      <b-row v-if="hasData || hasFilters">
        <b-col v-if="reportByBatchChosen">
          <h4 class="mb-3">Entrantes agrupados por Lote</h4>
          <b-table
            class="mb-5"
            :hover="true"
            outlined
            borderless
            responsive="md"
            :items="reportByBatch"
            :fields="batchFields">
          </b-table>
        </b-col>

        <b-col v-if="reportByDealerChosen">
          <h4 class="mb-3">Entrantes agrupados por Revendedor</h4>
          <b-table
            :hover="false"
            borderless
            responsive="md"
            :items="reportByDealer"
            :fields="dealerFields"
            :filter-included-fields='filterOn'>

            <template v-slot:cell(batches)="data">
              <b-table
                :hover="true"
                outlined
                :items="data.item.batches"
                :fields="batchFields">
              </b-table>
            </template>

          </b-table>
        </b-col>

        <b-col v-if="listValidationsChosen" cols="12">
          <h4 class="mb-3">Lista de Entrantes</h4>
          <b-table striped hover show-empty
            :items="report.ticket"
            :fields="fields"
            primary-key="id"
            sort-icon-left
            empty-filtered-text="Nenhum ingresso validado encontrado"
            empty-text="Nenhum ingresso validado encontrado"
            responsive
          >

            <template v-slot:cell(owner_data)="data">
              <div v-if="data.item.owner && data.item.owner.name && data.item.owner.document && data.item.owner.phone">
                <ul>
                  <li>{{ data.item.owner.name }}</li>
                  <li>{{ data.item.owner.document }}</li>
                  <li><b-link target="_blank" :href="mountWhatsAppLink(data.item.owner.phone)">{{ data.item.owner.phone }}</b-link> <icon scale="0.55" name="external-link-alt"></icon></li>
                </ul>
              </div>
            </template>

          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="filter-origin"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Origem"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('origins', $event)"
          :checked="filters.origins"
          :options="originsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-number"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Número"
      ok-variant="info"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('numbers', $event)"
          :value="filters.numbers"
          placeholder="Exemplo: 1,2,3"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.numbers" @click="filters.numbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-code"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Código"
      ok-variant="info"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os códigos e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('codes', $event)"
          :value="filters.codes"
          placeholder="Exemplo: 05a2c30de2e4c19bd8b5ae855ca40f00"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.codes" @click="filters.codes = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-range"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Intervalo"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o intervalo de números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('rangeNumbers', $event)"
          :value="filters.rangeNumbers"
          placeholder="Exemplo: 1-25"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.rangeNumbers" @click="filters.rangeNumbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-batch"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Lote"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group v-if="categoriesFromBatches.length > 0" label="Filtrar por categoria:">
        <b-form-select v-model="selectedCategoryFilter" :options="categoriesFromBatches" @change="filterByCategory"></b-form-select>
      </b-form-group>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.batch"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.batch" @click="search.batch = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('batches', $event)"
          :checked="filters.batches"
          :options="batchesOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-dealer"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Revendedor"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.dealer"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.dealer" @click="search.dealer = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('dealers', $event)"
          :checked="filters.dealers"
          :options="dealersOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Data"
      @ok="filter"
      :ok-disabled="filters.createdAt.start === '' || filters.createdAt.end === ''"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Para filtrar um <span class="font-weight-bold">intervalo de datas</span>, selecione dois dias. Para filtrar um <span class="font-weight-bold">dia específico</span>, clique duas vezes nele. Após isso clique em <span class="font-weight-bold">Filtrar</span>.</p>
      
      <div class="text-center">
        <calendar 
          @input="updateForm('createdAt', $event)"
          :value="filters.createdAt"
          :min-date="eventCreatedAt"
        >
        </calendar>
      </div>
    </b-modal>

  </div>
</template>

<script>
import TimeChart from './chart/TimeChart'
import MaskedInput from 'vue-text-mask'
import Calendar from '@/components/Calendar'
import FilterStore from '@/filterStore'

const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

const REPORT_BY_BATCH = 1
const REPORT_BY_DEALER = 2
const LIST_VALIDATIONS = 3

export default {
  name: 'Report',
  components: {
    TimeChart,
    MaskedInput,
    Calendar
  },
  data () {
    return {
      report: {
        entry: '',
        ticket: '',
        validation: '',
        generated_at: ''
      },
      currentStatus: null,
      organizer: '',
      randomNumberEnabled: false,
      chartEntranceValues: [],
      chartEntranceLabels: [],
      appliedFilters: [],
      dealers: [],
      batches: [],
      selectedCategoryFilter: null,
      search: {
        dealer: '',
        batch: ''
      },
      filters: {
        type: ['printed', 'digital'],
        origins: [],
        numbers: '',
        codes: '',
        rangeNumbers: '',
        batches: [],
        dealers: [],
        createdAt: {
          start: '',
          end: ''
        },
        limit: 10
      },
      typeOptions: [
        { text: 'Impressos', value: 'printed' },
        { text: 'Digitais', value: 'digital' },
      ],
      originsOptions: [
        { text: 'Sistema', value: 'dashboard' },
        { text: 'Aplicativo', value: 'app' },
        { text: 'Loja virtual', value: 'shop' },
      ],
      fields: [
        { key: 'number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'name', label: 'Lote', class: ['align-middle', 'text-nowrap'] },
        { key: 'dealer', label: 'Revendedor', class: ['align-middle', 'text-nowrap'] },
        { key: 'type', label: 'Tipo', formatter: this.$options.filters.ticketType, class: ['align-middle', 'text-center'] },
        { key: 'origin', label: 'Origem', formatter: this.$options.filters.ticketOrigin, class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'validated_at', label: 'Data validação', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'owner_data', label: 'Titular', tdClass: ['owner-data-column'], class: ['text-center', 'align-middle', 'text-nowrap'] },
      ],
      batchFields: [
        {key: 'batch', label: 'Lote'},
        {key: 'validate_amount', label: 'Total Validado', formatter: this.$options.filters.number, tdClass: ['text-success', 'text-center'], thClass: 'text-center'},
      ],
      dealerFields: [
        {key: 'name', label: 'Revendedor', tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'batches', label: 'Lotes'}
      ],
      filterOn: ['name'],
      optionsChart: [
        { text: 'Entrantes por Lote', value: REPORT_BY_BATCH },
        { text: 'Entrantes por Revendedor', value: REPORT_BY_DEALER },
        { text: 'Lista de Entrantes', value: LIST_VALIDATIONS }
      ],
      step: REPORT_BY_BATCH,
      eventCreatedAt: '',
      filterStore: ''
    }
  },
  created () {
    this.filterStore = new FilterStore(this.$route.params.organizer, this.$route.path)
    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    await this.getEvent()
    await this.filter()
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value)
    },
    filterByCategory (catId) {
      if (!catId) return
      const ids = this.batches.filter(b => b.category && b.category.id === catId).map(b => b.id)
      this.updateForm('batches', ids)
    },
    mountWhatsAppLink (phone) {
      if (!phone) return
      let numbers = String(phone).replace(/\D/g, '')
      return `https://api.whatsapp.com/send?phone=55${numbers}`
    },
    async getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      try {
        let res = await this.$http.get(url)

        if (res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }

        if (res.body.dealers.length > 0) {
          this.dealers = this.$_.orderBy(res.body.dealers, ['id'], ['asc'])
        }
        
        this.eventCreatedAt = this.$moment(res.body.created_at).format('YYYY-MM-DD 00:00:00')
        this.randomNumberEnabled = res.body.random_number_enabled === 1

        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    async getReport (filters) {
      let url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/time-report`

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        let res = await this.$http.get(url)

        this.report.entry = res.body.entry_time_report
        this.report.ticket = res.body.ticket_validations
        this.report.validation = res.body.print_validation_report
        this.report.generated_at = res.body.generated_at

        this.chartEntranceLabels = []
        this.chartEntranceValues = []

        this.$_.each(this.report.entry, (value) => {
          let dateBr = this.$moment(value.date).format('DD/MM')
          this.chartEntranceLabels.push(dateBr + ' ' + value.hour + ':00 - ' + value.hour + ':15')
          this.chartEntranceValues.push(value.first_quarter)

          this.chartEntranceLabels.push(dateBr + ' ' + value.hour + ':16 - ' + value.hour + ':30')
          this.chartEntranceValues.push(value.second_quarter)

          this.chartEntranceLabels.push(dateBr + ' ' + value.hour + ':31 - ' + value.hour + ':45')
          this.chartEntranceValues.push(value.third_quarter)

          this.chartEntranceLabels.push(dateBr + ' ' + value.hour + ':46 - ' + value.hour + ':59')
          this.chartEntranceValues.push(value.fourth_quarter)
        })
        this.currentStatus = STATUS_SUCCESS
        return true
      } catch (e) {
        console.error(e)
        this.currentStatus = STATUS_FAILED
      }
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.type.length > 0) {
        filters.push('type=' + this.$_.join(this.filters.type, ','))
      }

      if (this.filters.origins.length > 0) {
        filters.push('origins=' + this.$_.join(this.filters.origins, ','))

        let v = []
        this.$_.each(this.filters.origins, f => {
          let s = this.$_.find(this.originsOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Origem',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)

        let af = {
          filter: 'Número',
          values: this.filters.numbers
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.codes !== '') {
        filters.push('codes=' + this.filters.codes)

        let af = {
          filter: 'Código',
          values: this.filters.codes
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)

        let split = this.$_.split(this.filters.rangeNumbers, '-', 2)

        let af = {
          filter: 'Intervalo',
          values: 'Do ' + split[0] + ' até o ' + split[1]
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))

        let v = []
        this.$_.each(this.filters.batches, f => {
          let s = this.$_.find(this.batches, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Lote',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))

        let v = []
        this.$_.each(this.filters.dealers, f => {
          let s = this.$_.find(this.dealers, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Revendedor',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.start !== '') {
        let start = this.$moment(this.filters.createdAt.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_created_at=' + start + ':00')

        let af = {
          filter: 'Validação',
          values: 'A partir de ' + this.filters.createdAt.start
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.end !== '') {
        let end = this.$moment(this.filters.createdAt.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_created_at=' + end + ':59')

        let af = {
          filter: 'Validação',
          values: 'Até ' + this.filters.createdAt.end
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getReport(filters)
    },
    async showLast () {
      this.reset()
      await this.getReport("limit=10")
    },
    reset () {
      this.appliedFilters = []
      this.filters.dealers = []
      this.filters.batches = []
      this.filters.numbers = ''
      this.filters.codes = ''
      this.filters.rangeNumbers = ''
      this.filters.createdAt.start = ''
      this.filters.createdAt.end = ''
      this.filters.type = ['printed', 'digital']
      this.filters.origins = []
      this.filters.limit = 10
      this.filterStore.clear()
    },
  },
  computed: {
    reportByBatchChosen () {
      return this.step === REPORT_BY_BATCH
    },
    reportByDealerChosen () {
      return this.step === REPORT_BY_DEALER
    },
    listValidationsChosen () {
      return this.step === LIST_VALIDATIONS
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    },
    dealersOptions () {
      let filtered = this.dealers

      if (this.search.dealer) {
        filtered = this.$_.filter(this.dealers, d => {
          let searched = this.search.dealer.toLowerCase()
          return d.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchesOptions () {
      let filtered = this.batches

      if (this.search.batch) {
        filtered = this.$_.filter(this.batches, b => {
          let searched = this.search.batch.toLowerCase()
          return b.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    categoriesFromBatches () {
      const seen = {}
      const opts = [{ value: null, text: 'Selecione uma categoria...' }]
      for (const b of this.batches) {
        if (b.category && !seen[b.category.id]) {
          seen[b.category.id] = true
          opts.push({ value: b.category.id, text: `${b.category.emoji} ${b.category.category}` })
        }
      }
      return opts.length > 1 ? opts : []
    },
    reportByBatch () {
      let batches = this.$_.groupBy(this.report.validation, i => i.batch)
      let source = []

      this.$_.each(batches, batch => {
        let aux = this.$_.reduce(batch, (result, value, key) => {
          return {
            batch: value.batch,
            validate_amount: result.validate_amount + value.validate_amount,
          }
        }, {
          batch: '',
          validate_amount: 0,
        })
        source.push(aux)
      })

      let totals = this.$_.reduce(this.report.validation, (result, value, key) => {
        return {
          validate_amount: result.validate_amount + value.validate_amount,
        }
      }, {
        validate_amount: 0,
      })

      source.push(totals)

      return source
    },
    reportByDealer () {
      let aux = []

      this.$_.each(this.report.validation, i => {
        let found = this.$_.find(aux, elem => elem.name === i.dealer)

        if (!found) {
          aux.push({name: i.dealer, batches: [], sums: {validate_amount: 0}})
        }

        let idx = this.$_.findIndex(aux, elem => elem.name === i.dealer)

        aux[idx].batches.push({
          batch: i.batch,
          validate_amount: i.validate_amount,
        })

        aux[idx].sums.validate_amount += i.validate_amount
      })

      this.$_.each(aux, (v, i) => {
        aux[i].batches.push(aux[i].sums)
        delete aux[i].sums
      })

      return aux
    },
    hasData () {
      return this.report.ticket.length > 0
    }
  }
}
</script>
